// src/constants/messages.ts
export const messageConfig = {
  requestSong: {
    message:
      'Can’t find the song you’re looking for? Send us a request—we’ve got you covered!',
    message1: 'Can’t find the song you’re looking for?',
    message2: 'Send us a request—we’ve got you covered!',
    buttonText: 'Request Song',
  },
  receivedSong: {
    message:
      'Song Request received! Our team will review it to ensure it meets our guidelines. If approved, you’ll hear it soon!',
  },
};
